module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 5
// module chunks = 1 2 5 6